module.exports = __webpack_public_path__ + "static/img/about-step3.a71fac82.png";